import React, { useEffect, useState, useCallback } from 'react';
import styles from './Waveform.module.scss';
import waveformAvgChunker from '../../utils/waveFormChuncker';
import Spinner from '../../../common/components/Spinner';
import { useUIContext } from '../../context/UIContext';
import cx from 'classnames';
import { throttle } from 'engage/utils/general';

const CONTAINER_HEIGHT = 55;
const MIN_HEIGHT_COEF = 0.75;
const POINT_WIDTH = 2;
const POINT_MARGIN = 2;

const pointCoordinates = ({ index, pointWidth, pointMargin, containerHeight, amplitude }) => {
  const pointHeight = Math.abs(Math.round((amplitude / 100) * containerHeight));
  if (amplitude === 0) {
    console.log('amplitude === 0 pointHeight', pointHeight, 'y', containerHeight - pointHeight - verticalCenter);
  }
  const verticalCenter = Math.round((containerHeight - pointHeight) / 2);
  return [
    index * (pointWidth + pointMargin), // x starting point
    containerHeight - pointHeight - verticalCenter, // y starting point
    pointWidth, // width
    pointHeight, // height
  ];
};

const Waveform = ({ parentRef, waveformData, trimStartPos, progress, min }) => {
  const [chunkedData, setChunkedData] = useState(null);
  const [chunckNumber, setChunkNumber] = useState(null);
  const [pointWidth, setPointWidth] = useState(POINT_WIDTH);
  const [pointMargin, setPointMargin] = useState(POINT_MARGIN);
  const [calculatedPoints, setCalculatedPoints] = useState([]);

  const { miniSidebar } = useUIContext();

  const recalculateDimensions = () => {
    let calculatedChunkNumber = Math.round(parentRef?.current?.offsetWidth / (POINT_WIDTH + POINT_MARGIN));

    if (waveformData.length < calculatedChunkNumber) {
      setChunkNumber(waveformData.length);
      let pointSize = parentRef.current.offsetWidth / waveformData.length / 2;

      setPointWidth(pointSize);
      setPointMargin(pointSize);
    } else {
      setChunkNumber(calculatedChunkNumber);
      setPointWidth(POINT_WIDTH);
      setPointMargin(POINT_MARGIN);
    }
  };

  useEffect(() => {
    if (parentRef) {
      recalculateDimensions();
    }
  }, [parentRef.current, miniSidebar]);

  useEffect(() => {
    setTimeout(() => {
      recalculateDimensions();
    }, 200);
  }, [miniSidebar]);

  useEffect(() => {
    if (chunckNumber) {
      setChunkedData(waveformAvgChunker(waveformData, chunckNumber));
    }
  }, [chunckNumber]);

  const paintSvgs = (waveformData, trimStartPos, progress) => {
    if (waveformData) {
      return waveformData.map((wave, index) => {
        const coordinates = pointCoordinates({
          index,
          pointWidth: pointWidth,
          pointMargin: pointMargin,
          containerHeight: CONTAINER_HEIGHT * (min ? MIN_HEIGHT_COEF : 1),
          amplitude: wave,
        });
        const [x, y, w, h] = coordinates;
        const itemProgress = index / waveformData.length;
        return (
          <rect
            x={x}
            width={w}
            y={h === 0 ? y - 1 : y}
            height={h}
            rx={h === 0 ? 0 : 1}
            key={index}
            fill={itemProgress >= trimStartPos && itemProgress <= progress ? '#7C43AA' : '#BDBDBD'}
            stroke="none"
          />
        );
      });
    }
    return [];
  };

  const generateSvg = useCallback(() => {
    return paintSvgs(chunkedData, trimStartPos, progress);
  }, [chunkedData, trimStartPos, progress, min]);

  useEffect(() => {
    setCalculatedPoints(generateSvg);
  }, [chunkedData, progress, min]);

  useEffect(() => {
    const resizeWaveform = new ResizeObserver(throttle(entries => {
        entries.forEach(() => {
          recalculateDimensions();
        });
    }, 150));

    resizeWaveform.observe(parentRef.current);

    return () => resizeWaveform.disconnect();
  }, []);

  if (!chunkedData) {
    return <Spinner width="30px" height="30px" size="3px" />;
  }

  return <svg className={cx(styles.svgContainer, { [styles.min]: min })}>{calculatedPoints}</svg>;
};

export default Waveform;
